<template>

  <div class="row">
    <div class="col-md-3">
      <div class="card card-default">
        <div class="card-header">
          <h3 class="card-title">
            <i class="fas fa-list"></i>
            Time Table
          </h3>
          <div class="card-tools">
            <button type="button" style="padding:0px" class="btn" title="TimeTable" v-on:click="redirectTimeTable()">
              <i class="far fa-calendar-alt"></i>
            </button>
            <button type="button" class="btn btn-tool" data-card-widget="collapse" data-toggle="tooltip" title="Collapse">
              <i class="fas fa-minus"></i>
            </button>
          </div>
        </div>

        <div class="card-body">
          <div class="row">
              <div class="col-md-12">
                  <table v-if="Day" class="table table-sm table-bordered">
                      <tr class="bg-custom">
                          <th style="text-align:center">
                              <h5>{{Day}}</h5>
                          </th>
                      </tr>
                      <tr v-for="item in timetable">
                          <td style="text-align:center">
                              {{item.CourseName}} <br />
                              {{item.ClassName}} <br />
                              {{item.Time}} <br />
                              {{item.Venue}}
                          </td>
                      </tr>
                  </table>
                  <span v-else>No Class Today</span>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-9">
      <div class="card card-default">
        <div class="card-header">
          <h3 class="card-title">
            <i class="fas fa-list"></i>
            Assigned Courses
          </h3>
          <div class="card-tools" style="margin-top:10px">
            <button type="button" class="btn btn-tool" data-card-widget="collapse" data-toggle="tooltip" title="Collapse">
              <i class="fas fa-minus"></i>
            </button>
          </div>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-md-6" v-for="item in courses">
              <div class="callout callout-navy">
                <h5 class="crs-title">{{item.CourseTitle}}</h5>
                <p class="text-sm"> <small>{{item.Teacher}}</small></p>
                <div>
                  <button type="button" class="btn btn-action btn-sm btn-info" v-if="lessonPlan" v-on:click="LessonPlan(item.TeacherCourseAllotmentID)"> <i class="fas fa-users"></i> Lesson Plan</button>
                  <button type="button" class="btn btn-action btn-sm btn-success" v-if="lectureAttendance" v-on:click="Attendance(item.TeacherCourseAllotmentID)"><i class="fas fa-list-check"></i> Attendance</button>
                  <button type="button" class="btn btn-action btn-sm btn-warning" v-if="dailyDiary" v-on:click="redirectDailyDiary(item.TeacherCourseAllotmentID)"><i class="fas fa-arrow-up-1-9"></i> Diary</button>
                  <button type="button" class="btn btn-action btn-sm btn-primary" v-on:click="Result(item.TeacherCourseAllotmentID)"><i class="fas fa-list-ol"></i> Results</button>
                </div>
                <div v-if="item.Content">
                  <label>Diary For {{date}}</label>
                  <p v-html="item.Content"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card card-default">
        <div class="card-header">
          <h3 class="card-title">
            <i class="fas fa-list"></i>
            E-Exam
          </h3>
          <div class="card-tools" style="margin-top:10px">
            <button type="button" class="btn btn-tool" data-card-widget="collapse" data-toggle="tooltip" title="Collapse">
              <i class="fas fa-minus"></i>
            </button>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <div class="timeline">
                <!--<div class="time-label" v-if="examStatus != ''">
                  {{examStatus}}
                </div>-->
                <div v-for="(item,index) in exams">
                  <i :class="getClass1(index)"></i>
                  <div class="timeline-item">
                    <h3 class="timeline-header">
                      <a v-on:click="redirectExam(item.ExamID)">
                        {{item.Title}}
                        <span v-if="item.status == 'started'" class="badge-pill badge badge-warning">Started</span><span v-else class="badge-pill badge badge-primary">Upcoming</span>
                      </a>
                      <i class="float-right"> by <strong style="color: #736cc7" class="">{{item.TeacherName}}</strong></i>
                    </h3>
                    <div class="timeline-body">
                      <span class="time"><i class="fas fa-clock"></i> Scheduled At: {{item.Schedule}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card card-default">
        <div class="card-header">
          <h3 class="card-title">
            <i class="fas fa-list"></i>
            Assignments
          </h3>
          <div class="card-tools" style="margin-top:10px">
            <button type="button" class="btn btn-tool" data-card-widget="collapse" data-toggle="tooltip" title="Collapse">
              <i class="fas fa-minus"></i>
            </button>
          </div>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <div class="timeline">
                <!--<div class="time-label" v-if="examStatus != ''">
                  {{examStatus}}
                </div>-->
                <div v-for="(item,index) in tasks">
                  <i :class="getClass(index)"></i>
                  <div class="timeline-item">
                    <h3 class="timeline-header">
                      <a v-on:click="redirectLMS(item.AssignmentID)">
                        {{item.Name}}
                      </a>
                      <i class="float-right"> by <strong style="color: #736cc7" class="">{{item.EmployeeName}}</strong></i>
                    </h3>
                    <div class="timeline-body">
                      <span class="time"><i class="fas fa-clock"></i> open till {{item.End}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  export default {
    name: 'dashboard',

    data() {
      return {
        courses: [],
        timetable: [],
        subject: [],
        Day: '', 
        examStatus: 'Loading...',
        exams: [],
        tasks: [],
        lectureAttendance: false,
        lessonPlan: false,
        dailyDiary: false,
      }
       
    },
    created() {
      this.pageLoad();
      this.loadExams();
      this.getTasks();
    },
    methods: {

      //show up list of data form in table from database
      pageLoad() {
        var vm = this;
        axios.post('/api/PortalApi/pageLoadDashboard')
          .then(function (res) {
            vm.courses = res.data.courses;
            vm.dailyDiary = res.data.dailyDiary;
            vm.lectureAttendance = res.data.lectureAttendance;
            vm.date = res.data.date;
            vm.timetable = res.data.timetable;
            vm.Day = vm.timetable[0].Day;
            vm.subject = res.data.subject;
            vm.lessonPlan = res.data.lessonPlan;

          });
      },

      loadExams: function () {
        var vm = this;
        axios.post('/api/PortalApi/loadExams')
          .then(function (response) {
            vm.exams = response.data.exams;
            if (vm.exams.length == 0) {
              vm.examStatus = "No Exam found";
            }
            else
              vm.examStatus = "";
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      getTasks: function () {
        var vm = this;
        axios.post('/api/PortalApi/loadTasks?t=1')
          .then(function (response) {
            vm.tasks = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      redirectExam(ExamID) {
        window.location.href = '../Portal/ExamForm?id=' + ExamID;
      },

      redirectLMS(id) {
        window.location.href = '../Portal/UploadAssingment?id=' + id;
      },

      getClass: function (i) {
        if ((i % 2) == 0) {
          return "fa fa-tasks bg-yellow";
        }
        else {
          return "fa fa-tasks bg-purple";
        }
      },

      getClass1: function (i) {
        if ((i % 2) == 0) {
          return "fas fa-book bg-blue";
        }
        else {
          return "fas fa-book bg-green";
        }
      },

      Result(id) {
        window.location.href = "/Portal/Result?teacherID=" + id;
      },
      Attendance(id) {
        window.location.href = "/Portal/Attendance?teacherID=" + id;
      },
      LessonPlan(id) {
        window.location.href = "/Portal/LessonPlan?teacherID=" + id;
      },
      Assignment(id) {

        window.location.href = "Portal/Assignment?teacherID=" + id;
      },
      getContent(text) {
        var r = text.replace("\n", "<br/>");
        return r;
      },

      getTime(ID) {
        var data = this.timetable.find(u => u.Day == this.Day && u.CourseID == ID);
        if (data != null) {
          return data.Time;
        }
        else {
          return " - ";
        }
      },

      redirectTimeTable() {
        window.open("../Portal/TimeTable");
      },

      redirectDailyDiary(id) {
          window.location.href = "/Portal/DailyDairy?ID=" + id;
      }

    }
  }</script>

<style>
  .btn-action {
    margin-bottom: 4px;
  }

  .crs-title {
    border-bottom: 1px dashed black;
    padding-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard.vue